/**
 * Breakpoints — MUI's ladder, which the design language references by name (§4 "tablet",
 * §5 "phone (< md)"). Phone is below `md`; tablet is `sm`–`md`.
 */
export const BREAKPOINTS = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 };
/** The width below which the shell switches to the phone layout. */
export const PHONE_BREAKPOINT = 'md';
//# sourceMappingURL=breakpoints.js.map